import React from 'react'

import Page from '../../../../components/pdf/Page'

import Header from './Header'
import Service from './sections/Service'
import ClientData from './sections/ClientData'
import Budget from './sections/Budget'
import BudgetManual from './sections/BudgetManual'
import Terms from './sections/Terms'
import Signature from './sections/Signature'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import BudgetVivoManual from './sections/BudgetVivoManual'

const PdfDocument = ({ type, templateId }) => {
  const mainServiceOrder = useServiceOrder()

  const budgetManualIds = [608, 510]

  const budgetContent = () => {
    if (templateId === 6 && mainServiceOrder.checklist.id === 710) {
      return <BudgetVivoManual />
    }
    if (mainServiceOrder && budgetManualIds.includes(mainServiceOrder.checklist.id)) {
      return <BudgetManual />
    }

    return <Budget type={type} />
  }
  return (
    <Page header={<Header />}>
      <Service />
      <ClientData type={type} />
      {budgetContent()}
      <Terms />
      <Signature />
    </Page>
  )
}

export default PdfDocument
